const customColour = {
  oliveGreen: "#9bb44b",
  green: "#57a644",
  lightBlue: "#5799d5",
  darkBlue: "#01529e",
  darkerBlue: "#060f1a",
  white: "white",
  black: "black",
  grey: "grey",
  greyMix: "#0d0d0d",
  lightBackground: "#f8f8ff",
  darkBackground: "black",
  warning: "red",
  dataBackground: "#ebecf0",
};

export { customColour };
